import { createFileRoute, redirect } from '@tanstack/react-router';

// Redireciona / para /dashboard. Auth guard fica em _authed.
export const Route = createFileRoute('/')({
  beforeLoad: () => {
    throw redirect({ to: '/dashboard' });
  },
});
